export const notificationBodyWrapSx = { wordBreak: 'break-word' as const } as const

export const notificationMessageClampSx = {
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  textOverflow: 'ellipsis',
  minWidth: 0,
} as const
